//** Component  */
import React from "react";

//** Lib */

import ManageLinkupRequest from "./ManageLinkupRequest";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";


// console.log(data);
function LinkUpRequestList() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.LINKUPREQUESTOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.LINKUPREQUESTARCHIVETAB); 

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: < ManageLinkupRequest openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: < ManageLinkupRequest openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess
    
    },
  ];
  return (
    <>
     <CustomTab data={data} />
    </>
  );
}

export default LinkUpRequestList;
